import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('camo_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('camo_cart', JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, quantity = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i.product_id === product.product_id);
      if (existing) {
        return prev.map(i => i.product_id === product.product_id ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, { product_id: product.product_id, name: product.name, name_es: product.name_es, price: product.price, image: product.images?.[0], quantity }];
    });
  }, []);

  const removeItem = useCallback((product_id) => setItems(prev => prev.filter(i => i.product_id !== product_id)), []);

  const updateQuantity = useCallback((product_id, quantity) => {
    if (quantity <= 0) {
      setItems(prev => prev.filter(i => i.product_id !== product_id));
      return;
    }
    setItems(prev => prev.map(i => i.product_id === product_id ? { ...i, quantity } : i));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const total = useMemo(() => items.reduce((sum, i) => sum + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((sum, i) => sum + i.quantity, 0), [items]);

  // Memorizar valor del contexto para evitar re-render innecesarios
  const contextValue = useMemo(() => ({
    items, addItem, removeItem, updateQuantity, clearCart, total, count
  }), [items, addItem, removeItem, updateQuantity, clearCart, total, count]);

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
